import axios from 'axios'
import settings from 'settings'
export default async function trafficBetween(properties, start, end) {
	let user = localStorage.getItem("user")
	try {
		let data = await axios.post(
			settings.ep + "/trafficBetween",
			{ properties, start, end },
			{ headers: { Authorization: `Bearer ${user}` } }
		)
		return data
	}
	catch(e) {
		console.log(e)
	}
}